import React from 'react';
import cn from 'classnames';

import { isMobile } from 'app-constants';
import Icon from '../Icon';
import live from 'assets/svg/mob-live.svg';

import './LiveIcon.scss';

interface Props {}

const LiveIcon = (props: Props) => (
    <Icon
        glyph={live}
        styleName={cn('container', {
            'is-mob': isMobile,
        })}
        className="__app-LiveIcon-container"
    />
);

export default LiveIcon;
